import { Observer } from "mobx-react";
import translationStore from "stores/translation-store";
import { currencyFormat } from "utils/format";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift as discountIcon } from "@fortawesome/pro-light-svg-icons/faGift";
import style from "./style"

export default function CartPricing(props)
{
  const pricingOrder = ['subtotal', 'shipping', 'discount', 'giftcard', 'total'];
  const pricingSort = (a, b) =>
  {
    return pricingOrder.indexOf(a[0].split(".")[0]) - pricingOrder.indexOf(b[0].split(".")[0]);
  }

  return (
    <Observer>
    {
      () => {
        return (
          <div className="pricing">
            {
              props.pricing.sort(pricingSort).map(([key, value]) =>
              {
                const icon = key==='giftcard' ? <FontAwesomeIcon icon={discountIcon} /> : null;
                const prefix = (key==='discount' || key==='giftcard') ? '-' : null;

                return (
                  <div key={`pricing-row-${key}`} className={`pricing-row pricing-row-${key}`}>
                    <div className="pricing-row-description">{icon}{translationStore.translate(`shop.pricing.${key}`)}</div>
                    <div className="pricing-row-price">{prefix}{currencyFormat(props.language, props.currency, value / 100)}</div>
                  </div>
                )
              })
            }
            <style jsx>{style}</style>
          </div>
        )
      }
    }
    </Observer>
  );
}